import { Pagination } from '@mui/material';

// Types for ViewPagePagination
interface ViewPagePaginationProps {
  nbrOfPages: number;
  currentPage: number;
  handlePageChange: (page: number) => void;
}

export const ViewPagePagination = ({ nbrOfPages, currentPage, handlePageChange }: ViewPagePaginationProps) => (
  <Pagination count={nbrOfPages} page={currentPage} onChange={(event, val) => handlePageChange(val)} />
);
